<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>
      <template v-if="tipoOperacion == 1">
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="listaOT"
            item-key="idOT"
            sort-by="idOT"
            :search="buscar"
            :header-props="headerProps"
            :footer-props="$store.state.traduccionTabla"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
            <template v-slot:[`item.cantidadSaldo`]="{ item }">
              {{ getCantidadRestante(item.cantidad, item.cantidadUtilizada) }}
            </template>
          </v-data-table>

          <h1>Cables</h1>

          <v-data-table
            :headers="headersMaterialesBobina"
            :items="listaMaterialesBobina"
            item-key="idOT"
            sort-by="idOT"
            :search="buscarMaterialesBobina"
            :header-props="headerProps"
            :footer-props="$store.state.traduccionTabla"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
            <template v-slot:[`item.secInicio`]="{ item }">
              {{ getTextoSeccionInicio(item.secInicio, item.secFin) }}
            </template>
            <template v-slot:[`item.secFin`]="{ item }">
              {{ getTextoSeccionFin(item.secInicio, item.secFin) }}
            </template>
          </v-data-table>

          <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
        </v-container>
      </template>
      <template v-if="tipoOperacion == 2">
        <v-row justify="center" class="mt-4">
          <v-col cols="12" sm="6">
            <v-select
              v-model="contratistaSeleccion"
              :items="contratistas"
              item-value="idContratista"
              item-text="descripcionContratista"
              :menu-props="{ maxHeight: '400' }"
              prepend-icon="mdi-badge-account-outline"
              label="Seleccione un Contratista"
              no-data-text="No se encontraron contratistas"
              hint="Seleccione un contratista"
              persistent-hint
            ></v-select>
            <!-- <v-select
              v-model="contratistaSeleccion"
              :items="contratistas"
              item-value="idContratista"
              item-text="descripcionContratista"
              :readonly="readOnly"
            > 
            </v-select>-->
          </v-col>
        </v-row>
      </template>

      <template v-if="tipoOperacion == 3">
        <v-container fluid>
          <div class="text-h6 pa-12">
            {{ mensajeEliminar }}
          </div>
          <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
        </v-container>
      </template>

      <v-card-actions>
        <template v-if="tipoOperacion == 3">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cerrarOTContratistaConfirmacion"
            >Cerrar OT</v-btn
          >
        </template>
        <template v-if="tipoOperacion == 2">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="asignarOTContratistaConfirmacion"
            >Asignar</v-btn
          >
        </template>
        <template v-if="tipoOperacion == 1">
          <v-spacer></v-spacer>
        </template>
        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
//import sha512 from "js-sha512";
export default {
  data() {
    return {
      listaOT: [],
      listaMaterialesBobina: [],
      listaContratistas: [],
      mensajeEliminar: "",
      contratistas: [],
      readOnly: true,
      tipoOperacion: "",
      idOT: "",
      contratistaSeleccion: 0,
      dialog: false,
      colorDialogTitle: "",
      formTitle: "",
      headers: [
        {
          text: "Matricula",
          align: "start",
          sortable: true,
          value: "idMaterial",
          class: "black white--text",
        },
        { text: "Descripción", value: "nombre", class: "black white--text" },
        {
          text: "Cantidad Entregada",
          value: "cantidad",
          class: "green white--text",
        },
        {
          text: "Cantidad Utilizada",
          value: "cantidadUtilizada",
          class: "red white--text",
        },
      ],
      headersMaterialesBobina: [
        // {
        //   text: "Bobina",
        //   align: "start",
        //   sortable: true,
        //   value: "idBobinaC",
        //   class: "black white--text",
        // },
        // {
        //   text: "Bobina",
        //   align: "start",
        //   sortable: true,
        //   value: "idBobinaC",
        //   class: "black white--text",
        //   cell: (item) => item.bobina?.idBobinaC || "N/A",
        // },
        {
          text: "ID Cable",
          value: "idMaterialCable",
          class: "black white--text",
        },
        {
          text: "Descripcion Cable",
          value: "descripcionCable",
          class: "black white--text",
        },
        {
          text: "Seccion Inicio",
          value: "secInicio",
          class: "black white--text",
        },
        {
          text: "Seccion Fin",
          value: "secFin",
          class: "black white--text",
        },
        {
          text: "Cantidad Entregada (m)",
          value: "cantidadMetros",
          class: "green white--text",
        },
        {
          text: "Cantidad Utilizada",
          value: "cantidadUtilizada",
          class: "red white--text",
        },
      ],
    };
  },

  mounted() {
    console.log("Ingreso en modalContratistas");
    //this.getDetallesMateriales();
  },

  methods: {
    getTextoSeccionInicio(seccionInicio, seccionFin) {
      return seccionInicio == 0 && seccionFin == 0
        ? "Sin valor"
        : seccionInicio;
    },

    getTextoSeccionFin(seccionInicio, seccionFin) {
      return seccionInicio == 0 && seccionFin == 0 ? "Sin valor" : seccionFin;
    },

    async cerrarOTContratistaConfirmacion() {
      console.log("Ingreso en los cerrar la OT");
      this.url = this.$store.getters.urlBase + "OT/cerrarOT";

      console.log("La idOT es");
      console.log(this.url);

      var obj = {
        idOT: this.idOT,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      var respuesta = await axios
        .post(this.url, obj)
        .then((response) => {
          console.log("La respuesta es: ");
          console.log(response);
          return response;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.loadingButton = false;
      this.dialog = false;

      console.log("EL mensaje de la operacion");
      console.log(respuesta.data);
      if (respuesta.data.includes("Operacion Exitosa")) {
        console.log("Operacion Exitosa");
        this.$refs.dialogMensaje.abrirMensajeDialog(
          respuesta.data,
          2,
          "green",
          "Confirmacion"
        );
      } else {
        console.log("Operacion FAllida");
        this.$refs.dialogMensaje.abrirMensajeDialog(
          respuesta.data,
          2,
          "red",
          "Confirmacion"
        );
      }

      console.log("La respuesta data es: ");
      console.log(respuesta.data);
      console.log("Antes de ejecutar recargarListado");
      this.$emit("recargarListado");
    },

    cerrarOTModal(datos) {
      this.colorDialogTitle = "red";
      this.formTitle = "Cerra OT";
      this.dialog = true;
      this.tipoOperacion = 3;
      console.log("Ingreso en cerrar ot contratista");
      console.log(datos);
      this.mensajeEliminar = "Desea eliminar la OT " + datos.ord_ot + "?";
      this.idOT = datos.ord_ot;
      //this.$refs.dialogMensaje.cerrarOT(otSeleccionada);
    },

    async asignarOTContratistaConfirmacion() {
      console.log("Ingreso en los detalles de la OT");
      this.url = this.$store.getters.urlBase + "OT/ingresarOTContratista";

      console.log("La idOT es");
      console.log(this.url);

      var listaCajon = [];
      this.cajones = listaCajon;

      const data = {
        IdOT: this.idOT,
        IdContratista: this.contratistaSeleccion,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      //console.log("Los datos para enviar son");

      var respuesta = await axios
        .post(this.url, data)
        .then((response) => {
          return response;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.loadingButton = false;
      this.dialog = false;
      //this.dialog = true;
      //      this.getDetallesCuadrilla();
      console.log(respuesta.data);
      console.log("Antes de ejecutar recargarListado");
      this.$emit("recargarListado");
    },

    asignarOTContratista(otSeleccionada, listaContratistas) {
      console.log("Los datos de la ot son: ");
      console.log(listaContratistas);
      // console.log(otSeleccionada);
      //this.listaContratistas = listaContratistas;
      this.dialog = true;
      this.tipoOperacion = 2;
      this.formTitle = "Seleccione una contratista para asignar la OT ";
      this.idOT = otSeleccionada.ord_ot;
      this.colorDialogTitle = "green";
      this.getListarContratistas();
    },

    async abrirModalMaterialesOT(otSeleccionada) {
      this.dialog = true;
      this.tipoOperacion = 1;
      this.formTitle = "Materiales de la OT Nº " + otSeleccionada.ord_ot;
      this.idOT = otSeleccionada.ord_ot;
      this.colorDialogTitle = "blue";
      this.getDetallesMateriales();
      this.getDetallesMaterialesBobina();
    },

    async getDetallesMateriales() {
      this.listaOT = [];

      console.log("Ingreso en los detalles de la OT");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarMaterialesXOT?idOT=" +
        this.idOT +
        "&idContratista=" +
        this.$store.getters.usuario.idContratista;

      console.log("La idOT es");
      console.log(this.url);

      var listaCajon = [];
      this.cajones = listaCajon;

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaOT = response.data;
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.listaOT = respuesta;
      console.log("Los datos de la lista de materiales es");
      console.log(this.listaOT);

      this.loadingButton = false;
      this.dialog = false;
      this.dialog = true;
      this.getDetallesCuadrilla();
      //this.getDetallesMaterialesBobina();
    },

    async getDetallesMaterialesBobina() {
      this.listaOT = [];

      console.log("Ingreso en los detalles de la OT de bobina");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarMaterialesBobinaOperadorXOT?idOT=" +
        this.idOT;

      console.log("La idOT es");
      console.log(this.url);

      var listaCajon = [];
      this.cajones = listaCajon;

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales bobina cajon");
          console.log(response.data);
          this.listaOT = response.data;
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.listaMaterialesBobina = respuesta;
      console.log("Los datos de la lista de materiales bobina es");
      console.log(this.listaMaterialesBobina);

      this.loadingButton = false;
      this.dialog = false;
      this.dialog = true;
      //this.getDetallesCuadrilla();
    },

    abrirModalContratistaMateriales(datos) {
      this.dialog = true;
      this.colorDialogTitle = "blue";
      this.formTitle = "Materiales de la OT Nº " + datos.ord_ot;
      this.idOT = datos.ord_ot;
      this.getDetallesMateriales();
    },

    openModal() {
      this.dialog = true;
      this.colorDialogTitle = "indigo";
      this.formTitle = "Asignar OT a Contratista";
    },

    close() {
      this.dialog = false;
    },

    async ingresarOTContratista() {
      this.url = this.$store.getters.urlBase + "OT/ingresarOTContratista";

      const data = {
        IdContratista: this.contratistaSeleccion,
        IdOT: this.idOT,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("El arreglo de datos tiene esto:");
      console.log(data);

      await axios
        .post(this.url, data)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    getCantidadRestante(cantidadInicial, cantidadUtilizada) {
      return cantidadInicial - cantidadUtilizada;
    },

    async getListarContratistas() {
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      ///var listacontratista = [];
      //this.contratistas = listacontratista;

      await axios
        .get(this.url)
        .then((response) => {
          console.log("La lista de contrastistas es: ");
          console.log(response.data);
          this.contratistas = response.data;
          console.log("Este es el listado");
          console.log(this.contratistas);
          console.log(this.listaContratistas);
          const contratistasFiltrados = this.contratistas.filter(
            (contratista) =>
              !this.listaContratistas.includes(contratista.idContratista)
          );
          this.contratistas = contratistasFiltrados;
          // console.log(contratistasFiltrados);
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;

      // const contratistasFiltrados = this.contratistas.filter(
      //   (contratista) =>
      //     !this.listaContratistas.includes(contratista.idContratista)
      // );

      //console.log(contratistasFiltrados);
      //console.log(this.contratistas);
    },

    //async recuperar
  },
};
</script>
>
